export const internshipDetailsTranslations = {
  lv: {
    group: 'Prakšu norise',
    interns: 'Praktikanti',
    program: 'Prakses programma',
    programLabel: 'Programma',
    survey: 'Anketa',
    groups: 'Grupas',
    agreements: 'Līgumi',
    period: 'Periods',
    specialty: 'Specialitāte',
    supervisor: 'Noklusētais vadītājs',
    open: 'Ieraksts atvērts',
    weekly: 'Limits nedēļā',
    days: '{{count}} dienas',
    missing: '{{count}} praktikantiem nav prakses vietas.',
    missingHelp:
      'Bez prakses vietas nevar izveidot līgumu un praktikants nevar sākt rakstīt dienasgrāmatu.',
    loadError: 'Neizdevās ielādēt praksi',
    resourceError: 'Neizdevās ielādēt datus',
    back: 'Atpakaļ uz praksēm',
    search: 'Meklēt praktikantu...',
    empty: 'Nav praktikantu',
    intern: 'Praktikants',
    studentGroup: 'Grupa',
    place: 'Prakses vieta',
    eduSupervisor: 'Prakses vadītājs izglītības iestādē',
    records: 'Ieraksti',
    hours: 'Stundas',
    toGrade: '{{count}} jāvērtē',
    noPlace: 'Nav piešķirta',
    planPoint: 'Plāna punkts',
    grader: 'Vērtētājs',
    question: 'Jautājums',
    type: 'Tips',
    weight: 'Svars',
    noItems: 'Nav ierakstu',
    inactive: 'Neaktīvs',
  },
  en: {
    group: 'Internship management',
    interns: 'Interns',
    program: 'Practice program',
    programLabel: 'Program',
    survey: 'Questionnaire',
    groups: 'Groups',
    agreements: 'Agreements',
    period: 'Period',
    specialty: 'Specialty',
    supervisor: 'Default supervisor',
    open: 'Record open',
    weekly: 'Weekly limit',
    days: '{{count}} days',
    missing: '{{count}} interns have no placement.',
    missingHelp:
      'An agreement cannot be created and the intern cannot start their diary without a placement.',
    loadError: 'Could not load internship',
    resourceError: 'Could not load data',
    back: 'Back to internships',
    search: 'Search interns...',
    empty: 'No interns',
    intern: 'Intern',
    studentGroup: 'Group',
    place: 'Placement',
    eduSupervisor: 'Institution supervisor',
    records: 'Records',
    hours: 'Hours',
    toGrade: '{{count}} to grade',
    noPlace: 'Not assigned',
    planPoint: 'Plan item',
    grader: 'Grader',
    question: 'Question',
    type: 'Type',
    weight: 'Weight',
    noItems: 'No items',
    inactive: 'Inactive',
  },
}
